import cardM from './card-M.vue'
import cardM1 from './card-M1.vue'
import cardV from './card-V.vue'
import daraRangeM from './daraRange-M.vue'
import toptool from './top-tool.vue'
import cardTable from './card-table.vue'
// import CardInfoTable3  from './card-info-table3.vue'
// import CardInfoTable2  from './card-info-table2.vue'
// import CardInfoTable1  from './card-info-table1.vue'
import CardInfoTable  from './card-info-table.vue'
import paging from './paging.vue'
import cardSearch from './card-search.vue'
import AppBreadcrumb from './AppBreadcrumb.vue';
// import cardTablePro from './card-table-pro.vue'
// 这里是重点
const card = {
    install: function(Vue){
        Vue.component('cardM', cardM)
        Vue.component('cardM1', cardM1)
        Vue.component('cardV', cardV)
        Vue.component('daraRangeM',daraRangeM)
        Vue.component('toptool',toptool)
        Vue.component('cardTable', cardTable)
        // Vue.component('CardInfoTable3', CardInfoTable3)
        // Vue.component('CardInfoTable2', CardInfoTable2)
        // Vue.component('CardInfoTable1', CardInfoTable1)
        Vue.component('CardInfoTable', CardInfoTable)
		Vue.component('paging', paging)
		Vue.component('cardSearch', cardSearch)
        Vue.component('AppBreadcrumb', AppBreadcrumb);
        // Vue.component('cardTablePro', cardTablePro)
    }
}

// 导出组件
export default card